import styled from "styled-components";
import {
  DesktopDatePicker as DesktopPicker,
  LocalizationProvider as LocalProvider,
} from "@mui/x-date-pickers";

import { TextField as Input } from "@mui/material";

export const DesktopDatePicker: any = styled(DesktopPicker)``;

export const LocalizationProvider = styled(LocalProvider)`
  display: flex;
  align-items: center;
`;

export const TextField = styled(Input)`
  width: 100%;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 40px;
  }
  .MuiInputBase-root {
    height: ${(props: any) => `${String(props.height)}px` || "30px"};
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: #c0c0c0 !important;
    }
  }
  .MuiOutlinedInput-input {
    padding-top: 10.5px;
    padding-bottom: 10.5px;

    font-size: 14px;
    font-family: "Inter";
    color: #333333;
    font-weight: 400;
  }
`;
